export const bingReportSignUp = () => {
  window.uetq = window.uetq || [];

  window.uetq.push("event", "submit_lead_form", {
    event_label: "e6b61285-e125-425d-ba7d-96b5eec4f10f",
  });
};
